import styled from 'styled-components';
import { useTranslation } from 'next-i18next';
import Slider from './Slider';
import { useSelector } from 'react-redux';
import GridCard from './cards/GridCard';
import { EntityTypes } from '../new-lib/constants/common';
import RecommendedPropertyCard from '../features/home/components/recommended-section/RecommendedPropertyCard';

interface SuggestedContainerProps {
  suggestedProperties?: any[];
  suggestedCompounds?: any[];
}

const SuggestedContainer = ({
  suggestedProperties,
  suggestedCompounds
}: SuggestedContainerProps) => {
  const { t } = useTranslation('entity');
  const isMobile = useSelector((state: any) => state.app.isMobile);

  const getSliderChildren = () => {
    let sliderChildren: any = [];
    if (suggestedProperties && suggestedProperties.length > 0) {
      suggestedProperties.forEach((item: any, index: number) => {
        sliderChildren.push(
          <RecommendedPropertyCard
            entity={item}
            entityType={EntityTypes.PROPERTY}
            key={item?.id ?? index}
            isNawyNow={false}
            clickEventData={{
              property: item,
              eventAction: 'prop_click',
              eventLocation: 'RecommendedSection',
              index: index,
              compound: item.compound,
              area: item.area,
              recommended: true,
              featureName: 'property'
            }}
            recommendedClick={true}
            cardPosition={index}
          />
        );
      });
    } else if (suggestedCompounds && suggestedCompounds.length > 0) {
      suggestedCompounds.forEach((item: any, index: number) => {
        sliderChildren.push(
          <GridCard
            entity={item}
            entityType={EntityTypes.COMPOUND}
            cardPosition={index}
            key={item.toString()}
            clickEventData={{
              property: item,
              eventAction: 'cmpnd_click',
              compound: item,
              area: item.area,
              eventLocation: 'RecommendedSection',
              index: index,
              recommended: true,
              featureName: 'compound'
            }}
            recommendedClick={true}
          />
        );
      });
    }
    return sliderChildren;
  };

  const recommendedSliderProps = {
    slidesPerView: 'auto' as 'auto',
    spaceBetweenSlides: !isMobile ? 10 : 5,
    slidesPerGroup: 1,
    children: getSliderChildren(),
    width: !isMobile ? '420px' : '90%',
    height: '415px'
  };

  if (!suggestedProperties?.length && !suggestedCompounds?.length) {
    return <></>;
  }

  return (
    <SuggestedWrapper data-test="suggested-compounds">
      <h2 className="headline-3 entity-title">
        {suggestedProperties
          ? t('suggested_properties')
          : t('suggested_compounds')}
      </h2>
      <Slider {...recommendedSliderProps} />
    </SuggestedWrapper>
  );
};

const SuggestedWrapper = styled.div`
  height: auto;
  display: flex;
  flex-direction: column;
  justify-self: flex-start;
  margin-top: 32px;
  .price-cta-section {
    height: 60px;
    align-items: flex-end;
    .payment-details {
      height: 38px;
      text-align: start;
    }
  }
  @media screen and (max-width: ${props =>
      props.theme.breakPoints.desktop.min}) {
    gap: 5px;
  }
`;

export default SuggestedContainer;
